import type { GetMeUserResponse } from "@nlc/shared-types";

import { USER_ROLES } from "@nlc/shared-types";
import { createFileRoute, redirect } from "@tanstack/react-router";

import { ListTeamsPage } from "@/features/teams";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/_auth/_app-shell/teams/")({
  beforeLoad: async ({ context }) => {
    const userData = context.queryClient.getQueryData<GetMeUserResponse>([
      "user",
    ]);

    // Redirect collaborators to request page
    if (userData?.user?.roleName === USER_ROLES.COLLABORATOR) {
      throw redirect({ to: "/requests" as string });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("Teams");

  return <ListTeamsPage />;
}
